import { ListItemCheckbox } from 'lib/list';
import styled from 'styled-components';

const ContextMenuListItemCheckbox = styled(ListItemCheckbox)``;

export { ContextMenuListItemCheckbox };
